<template>
  <v-row>
    <v-col cols="6" class="py-0">
      <v-row>
        <v-col cols="6">
          <metric-kpi metric="net_billing" interval="yearly" comparative="this_v_last_mtd" />
        </v-col>
        <v-col cols="6">
          <metric-kpi metric="net_billing" interval="monthly" comparative="this_v_last_mtd" />
        </v-col>
        <v-col cols="6">
          <metric-kpi metric="total_billing" interval="yearly" comparative="this_v_last_mtd" />
        </v-col>
        <v-col cols="6">
          <metric-kpi metric="total_billing" interval="monthly" comparative="this_v_last_mtd" />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="6">
      <metric-graph metric="total_billing" />
    </v-col>
    <v-col cols="12" class="py-0">
      <v-row>
        <v-col cols="3">
          <metric-kpi metric="total_cancelled_billing" interval="monthly" comparative="this_v_last_mtd" />
        </v-col>
        <v-col cols="3">
          <metric-kpi metric="total_billing_non_recurring" interval="monthly" comparative="this_v_last_mtd" />
        </v-col>
        <v-col cols="3">
          <metric-kpi metric="total_tax" interval="monthly" comparative="this_v_last_mtd" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import MetricKpi from '@/components/reports/MetricKpi'
import MetricGraph from '@/components/reports/MetricGraph'

export default {
  components: {
    MetricKpi,
    MetricGraph
  }
}
</script>
